"use strict";

module.exports = function (accumulator, order, product, component) {
  var addition = '';

  if ("".concat(component.queue).match(/4\d\d-11x17/) && "".concat(component.paper_type).match(/ivory/gi)) {
    addition = 'Please use temporary Mohawk 100 11x17. See Jeff with any questions.';
  }

  if (accumulator.length && addition.length) {
    return "".concat(accumulator, "\n").concat(addition);
  }

  return "".concat(accumulator).concat(addition);
};